import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `${process.env.REACT_APP_SITEURL}/subtitles`;
// const SERVER_URL = `http://localhost:4009/subtitles`;

const UploadSubtitlesApi = async (
  data,
  handleSubtitlesUploadPercent,
  indexSub
) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/UploadSubtitles`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
      onUploadProgress: (data) => {
        handleSubtitlesUploadPercent(data.loaded / data.total, indexSub);
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await UploadSubtitlesApi(
          data,
          handleSubtitlesUploadPercent,
          indexSub
        );
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const editSubtitlesApi = async (data, handleSubtitlesUploadPercent) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/editSubtitles`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.patch(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
      onUploadProgress: (data) => {
        handleSubtitlesUploadPercent(data.loaded / data.total);
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await editSubtitlesApi(data, handleSubtitlesUploadPercent);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const deleteSubtitlesApi = async (dataObject) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/removeSubtitles`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.delete(url, {
      data: dataObject,
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await deleteSubtitlesApi(dataObject);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const scoreSubtitlesApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/scoreSubtitles`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await scoreSubtitlesApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const createNewGroupIdApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/createNewGroupId`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await createNewGroupIdApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const getSubtitlesApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/getSubtitles`;
    let token = JSON.parse(localStorage.getItem("token"));
    const {subtitlesUploadId}=data
    if(subtitlesUploadId.length==10) {
      return await axios.get(`https://sub.umlang.com/subs/subtitles/${subtitlesUploadId}.srt`);
    }
    return await axios.post(url, data, {
      responseType: "blob",
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getSubtitlesApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getSubtitlesApi(data);
      } else throw error;
    }
  }
};

const addCommemtApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/addCommemt`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await addCommemtApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const findSubtitlesWithIdApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/findSubtitlesWithId`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await findSubtitlesWithIdApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const findSubtitlesApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/findSubtitles?limit=${
      paginate.perPage || 50
    }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await findSubtitlesApi(data, paginate);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const getSubtitlesCommentsApi = async (data, paginate) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/getSubtitlesComments?limit=${
      paginate.perPage || 10
    }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getSubtitlesCommentsApi(data, paginate);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const uploadCoverApi = async (data, handleCoverUploadPercent) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/uploadCover`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
      onUploadProgress: (data) => {
        // console.log(data.loaded)
        // console.log(data.total)
        handleCoverUploadPercent(data.loaded / data.total);
        // console.log(data.loaded / data.total)
        // setProgress(Math.round(100 * (data.loaded / data.total)));
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await uploadCoverApi(data, handleCoverUploadPercent);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const getSubtitlesInfoApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/subtitles/getSubtitlesInfo`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getSubtitlesInfoApi(data);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

const findeCoverApi = async (data, paginate) => {
  try {
    console.log(data, paginate);
    const url = `${SERVER_URL}/api/v1/subtitles/findeCover?limit=${
      paginate.perPage || 50
    }&page=${paginate.page || 1}`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await findeCoverApi(data, paginate);
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error);
      throw error;
    }
  }
};

export {
  UploadSubtitlesApi,
  createNewGroupIdApi,
  editSubtitlesApi,
  deleteSubtitlesApi,
  findSubtitlesWithIdApi,
  findSubtitlesApi,
  scoreSubtitlesApi,
  addCommemtApi,
  getSubtitlesApi,
  getSubtitlesCommentsApi,
  uploadCoverApi,
  getSubtitlesInfoApi,
  findeCoverApi,
};
